$(document).ready(function(){

    mobileButtons();
    fixedMenu();
    singleSlider();
    productCategoriesSlider();
    productRelatedSlider();

    $(window).on('resize', function(){
        if($(this).width()>768){
            $('body').removeClass('mobile').removeClass('search-mobile');
        }
    });

    $(window).on('scroll', function(){

        if($(this).scrollTop()>0){
            $('body').addClass('fix-menu');
        }else{
            $('body').removeClass('fix-menu');
        }

    });

    $('body').click(function () {
        document.activeElement.blur();
    });

    $('input, textarea').click(function (event) {
        event.stopPropagation();
    });

    $('.rp-wrap').on('click', function(e) {
        if (e.target !== this)
          return;
        
        $(this).fadeOut(500);
        $('.rp-form-wrap').removeClass('loaded');
        
    });

    $('.closePopUp').on('click touch', function(e) {
        e.preventDefault();
        $('.rp-wrap').fadeOut(500);
        $('.rp-form-wrap').removeClass('loaded');
        $('html').removeClass('popup-open');
    });


    function openPricingForm(){

        $('html').addClass('popup-open');
        
        $('.rp-wrap').fadeIn(500, function(){
            $('.rp-form-wrap').addClass('animated zoomIn');
            if(document.getElementById("request-price-map")){
                var myLatLng = {lat: 40.74342205763919, lng: -73.98521604229734};
                var map = new google.maps.Map(document.getElementById('request-price-map'), {
                zoom: 15,
                center: myLatLng,
                scrollwheel: false,
                navigationControl: false,
                mapTypeControl: false,
                scaleControl: false,
                draggable: true,
                disableDefaultUI: true,
                styles: [
                    {
                      "featureType": "poi.business",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "featureType": "poi.park",
                      "elementType": "labels.text",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    }
                  ]
                });
            }
            
            $('.gmap-info').addClass('loaded');

        });
    }

    $('.btnRequestPricing').on('click touch', function(e){

        e.preventDefault();
        openPricingForm();
        
    });

    

    $('.page-content .share').on("click", function(e) {
      $(this).sharePopup(e);
    });
    
    $(window).on('load', function(){

        if($('#contactForm')){
            $('#contactForm').formSubmit();
        }
        
        if($('#requestForm')){
            $('#requestForm').formSubmit();
        }

        $('.footer-subscribe').formSubscribe();
        $('.sidebar-subscribe').formSubscribe();
        $('.subscribe-popup .sbs-form').formSubscribe();


    });

    
    $(document).on('click touch', '.btnQuickLook', function(e){
        
        e.preventDefault();
        
        var wine_id = $(this).attr('data-wine');

        $.ajax({
            url: ajaxurl,
            dataType: 'json',
            type: 'POST',
            data: {'action'  : 'getWineQuickLook', 'wine_id' : wine_id },
            success: function(resp){

                var wp = $('.wine-popup');
                
                $(wp).find('.wine-name').html(resp.name);
                $(wp).find('.wine-subtitle').html(resp.subtitle);
                $(wp).find('.wine-text').html(resp.desc);

                if(resp.points!==''){
                    $(wp).find('.wine-points').html(resp.points + ' points');
                }else{
                    $(wp).find('.wine-points').html('');
                }
                
                $(wp).find('.wine-dollars').html(resp.price);

                if(resp.pricing_list){
                    $(wp).find('.btnPriceList').attr('href', resp.pricing_list);
                }else{
                    $(wp).find('.btnPriceList').hide();
                }

                $(wp).find('.wine-popup-slider').html('');
                
                for(var i=0;i<resp.slider.length;i++){
                    $(wp).find('.wine-popup-slider').append('<div style="background-image: url('+ resp.slider[i] +');" class="wine-slide"></div>');
                }

                $(wp).find('.wp-mail-share').attr('href', 'mailto:?subject=' + resp.name);
                $(wp).find('.wp-fb-share').attr('href', 'https://www.facebook.com/sharer/sharer.php?u=' +resp.link);
                $(wp).find('.wp-tw-share').attr('href', 'https://twitter.com/share?url=' +resp.link);
                $(wp).find('.wp-gp-share').attr('href', 'https://plus.google.com/share?url=' +resp.link);
                
                $(wp).find('.btn-see-full-details').attr('href', resp.link);

                $('.wine-popup-box').addClass('animated zoomIn');

                setTimeout(function(){
                    $(".wine-popup-slider").slick({
                        dots: true,
                        arrows:false,
                        infinite: true,
                        autoplay: true,
                        speed: 500,
                        easing: 'easeOutElastic',
                        slidesToShow: 1
                    });
                }, 1000);

            },
            complete: function(){
                $('.wine-popup').addClass('loaded');
                $('html').addClass('popup-open');
            }
        });

        


    });

    $('.closeWine').on('click touch', function(e){

        e.preventDefault();
        $('.wine-popup').removeClass('loaded');
        $('.wine-popup-box').removeClass('animated zoomIn');
        $(".wine-popup-slider").slick('unslick');

        $('html').removeClass('popup-open');

    });


    $(document).on('click touch', '.btn-full-price-list', function(e){
        
        e.preventDefault();

        if(!$(this).hasClass('btn-single-pricelist')){

            $('.wine-popup').removeClass('loaded');
            $('.wine-popup-box').removeClass('animated zoomIn');
            $(".wine-popup-slider").slick('unslick');
    
            $('html').removeClass('popup-open');
    
        }

        openPricingForm();

    });

    $( ".ftr-sitemap ul li a:contains('Pricelist')").on('click touch', function(e){
        
        e.preventDefault();

        if(!$(this).hasClass('btn-single-pricelist')){

            $('.wine-popup').removeClass('loaded');
            $('.wine-popup-box').removeClass('animated zoomIn');
            $(".wine-popup-slider").slick('unslick');
    
            $('html').removeClass('popup-open');
    
        }

        openPricingForm();

    });

    



    $(document).on('touchstart', '.related-products .related-slider .related-slide-item .info-image-col, .wine-tab-content .info-row .info-image-col', function(){
        $('.related-products .related-slider .related-slide-item .hovered, .wine-tab-content .info-row .hovered').removeClass('hovered');
        $(this).addClass('hovered');
    });


    $('.shareThisWrap a').on('click touch', function(e){

        var url = $(this).attr('href');
        
        if(url.indexOf('mailto')===-1){
        
            e.preventDefault();
            var w = 550;
            var h = 450;
    
            var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
            var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;
        
            var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
            var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;
        
            var left = ((width / 2) - (w / 2)) + dualScreenLeft;
            var top = ((height / 2) - (h / 2)) + dualScreenTop;
            var newWindow = window.open(url, 'Share Window', 'toolbar=0, location=0, menubar=0, directories=0, scrollbars=0, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
            
            return false;
        
        }

         
    });


    

    $(".wine-slider").slick({
        dots: true,
        arrows:false,
        infinite: true,
        autoplay: true,
        speed: 500,
        easing: 'easeOutElastic',
        slidesToShow: 1
    });
    

});


var freezeVp = function(e) {
    e.preventDefault();
};




function mobileButtons(){

    $('#mobMenuBtn').on('click touch', function(e){
        e.preventDefault();
        $('body').toggleClass('mobile');
        $('body').removeClass('search-mobile');
    });

    $('#searchBtn, .search-nav a').on('click touch', function(e){
        e.preventDefault();
        $('body').toggleClass('search-header');
        $('body').removeClass('mobile');
    });

    $(document).on("click touch", function(e){ 
        if (($(e.target).is("body") || $("body").has(e.target).length) && (!$(e.target).is('.search-nav a') && !$('.search-nav').has(e.target).length)) {
            if($('body').hasClass('search-header')){
                $('body').removeClass('search-header');
            }
        }
       
    });​​​​​​​

}

function fixedMenu(){}



function showContentScroll(){
    $(window).scroll(function(){
        checkInView();
    });
}

function checkInView(){
    
    var key_position = $(window).scrollTop() + $(window).height();

    $('.full-section:not(.welcome) .vertical-align-wrap').each(function(){
        if(key_position > $(this).offset().top+120){
            $(this).children('*').addClass('loaded');
        }
    });

    if(key_position > $('.projects').offset().top+120){
        $('.projects').children('*').addClass('loaded');
    }

}

function singleSlider(){
    
    $(".single-slider").slick({
        centerMode: true,
        centerPadding: '0px',
        dots: true,
        arrows:false,
        infinite: true,
        autoplay: true,
        variableWidth: true,        
        autoplaySpeed: 3000,
        pauseOnHover: false,
        speed: 1000,
        easing: 'easeOutElastic',
        slidesToShow: 1,
        adaptiveHeight: true
    });

    $(".single-slider").on('init', function(){
        $(this).addClass('slick-loaded');
    });
    

}

function productCategoriesSlider(){

    $(".wine-categories").slick({
        dots: false,
        arrows:true,
        infinite: false,
        autoplay: false,
        speed: 200,
        easing: 'easeOutElastic',
        slidesToShow: 8,
        adaptiveHeight: true,
        prevArrow: '<a class="slick-prev" href="#"><i class="fa fa-angle-left" aria-hidden="true"></i></a>',
        nextArrow: '<a class="slick-next" href="#"><i class="fa fa-angle-right" aria-hidden="true"></i></a>',
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                infinite: false,
                centerMode: false
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: false,
                centerMode: false
              }
            }
          ]
    });

}

function productRelatedSlider(){

    $(".related-slider").slick({
        dots: false,
        arrows:true,
        infinite: false,
        autoplay: false,
        speed: 200,
        easing: 'easeOutElastic',
        slidesToShow: 4,
        adaptiveHeight: true,
        prevArrow: '<a class="slick-prev" href="#"><i class="fa fa-angle-left" aria-hidden="true"></i></a>',
        nextArrow: '<a class="slick-next" href="#"><i class="fa fa-angle-right" aria-hidden="true"></i></a>',
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true,
                centerMode: false
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                slidesToScroll: 1
              }
            }
          ]
    });

}


$.fn.sharePopup = function (e, intWidth, intHeight, blnResize) {
    
    // Prevent default anchor event
    e.preventDefault();

    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : screen.top;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    // Set values for window
    intWidth = intWidth || '500';
    intHeight = intHeight || '400';
    strResize = (blnResize ? 'yes' : 'no');

    var left = ((width / 2) - (intWidth / 2)) + dualScreenLeft;
    var top = ((height / 2) - (intHeight / 2)) + dualScreenTop;

    // Set title and open popup with focus on it
    var strTitle = ((typeof this.attr('title') !== 'undefined') ? this.attr('title') : 'Social Share'),
        strParam = 'width=' + intWidth + ',height=' + intHeight + ',resizable=' + strResize + ',top=' + top + ',left=' + left,    
        objWindow = window.open(this.attr('href'), strTitle, strParam).focus();

}


$.fn.formSubmit = function (){
    
    var this_form = $(this);
    var form_data = {};
    var token;
    var contact_loader = $(this_form).find('.contact-loader');
    var recaptcha = $(this_form).find('.g-recaptcha')[0];

    if(recaptcha){

        var recaptcha_widget = grecaptcha.render(recaptcha ,{
            'sitekey' : '6Ldn6jkUAAAAAELj62XVtOFjYQosOJ2wzozb1e84',
            'callback' : function(){
                $(this_form).find('.g-recaptcha.error-rqrd').removeClass('error-rqrd');
            },
            'theme' : 'light'
        });

    }

    
    $(this_form).on('submit', function(e){
        
        e.preventDefault();

        if(handleValidation($(this))){
            
            $(this_form).find('input, textarea').each(function(){
                
                var name_key = $(this).attr('id');

                if($(this).prop('type')!=='checkbox'){
                    if($(this).val()!=='' && name_key!==undefined){
                        form_data[name_key] = $(this).val();
                    }
                }else{
                    if($(this).is(":checked")){
                        form_data[name_key] = 1;
                    }else{
                        form_data[name_key] = 0;
                    }
                }
                

            });


            $(contact_loader).addClass('active');

            token = grecaptcha.getResponse(recaptcha_widget);

            //send the formData via AJAX
            setTimeout(function(){

                $.ajax({
                    url: ajaxurl,
                    dataType: 'json',
                    type: 'POST',
                    data: {'action'  : 'submitContactForm', 'captcha_token' : token , 'form_data' : JSON.stringify(form_data)},
                    success: function(resp){

                        if(resp===1){
                            $(contact_loader).removeClass('active').addClass('success');
                            $(contact_loader).find('.nf-msg').html('Thank you for contacting us.<br><br>We are reviewing the information you have submitted and<br>will be in contact with you as soon as possible!');
                        }else{
                            $(contact_loader).removeClass('active').addClass('error');
                            $(contact_loader).find('.nf-msg').text('There was a problem submitting the form. Please try again. ' + resp);
                        }
                        
                    },
                    error: function(){
                        $(contact_loader).removeClass('active').addClass('error');
                        $(contact_loader).find('.notification-msg').text('There was a problem submitting the form. Please try again. ' + resp);
                    },
                    complete: function(){
                        clearInputs(this_form);
                    }
                });

            }, 2000);
            
        }else{
            return false;
        }
    
    });
    

    $(this_form).find('input, textarea, .g-recaptcha, .g-recaptcha *').on('click touch focus', function(){
        $(this).removeClass('error-rqrd');
        checkAllRequired(this_form);
    });


    $(this_form).find('.nfBack').on('click touch', function(e){
        e.preventDefault();
        $('.contact-loader').removeClass('success error');

        if($(this_form).attr('id')=="requestForm"){
            $('.rp-wrap').fadeOut(500);
            $('.rp-form-wrap').removeClass('loaded');
            $('html').removeClass('popup-open');
        }

    });


    function handleValidation(form){
        
        var all_clear = true;

        $(form).find('.required').each(function(){
            
            var this_val = $(this).val();
            
            if(emptyValidation(this_val)===0){
                $(this).addClass('error-rqrd');
                $(form).find('.contact-status').addClass('fadeIn').text('The fields with * are required.');
                all_clear=false;
            }
    
        });


        token = grecaptcha.getResponse(recaptcha_widget);

        if(token==='' || token===undefined){
            $(recaptcha).addClass('error-rqrd');
            all_clear=false;
        }

        checkAllRequired(this_form);

        return all_clear;
    
    }

    function clearInputs(form){
        
        $(form).find('input[type=text], input[type=email], textarea').each(function(){
            $(this).val('');
        });

        $(form).find('input[type=checkbox]').prop('checked', false);

        grecaptcha.reset();
    }
    
    function emptyValidation(value){
        if(value!=="" && value!==undefined && value.length>1 && value!==null && value!==false){
            return 1;
        }else{
            return 0;
        }
    }

    function checkAllRequired(this_form){
        var all_clear=0;
        var all=0;

        $(this_form).find('.required').each(function(){
            var this_val = $(this).val();
            all_clear += emptyValidation(this_val);
            all++;
        });

        if(all_clear===all){
            $(this_form).find('.contact-status').removeClass('fadeIn');
        }
    }

}


$.fn.formSubscribe = function (){
    
    var this_form = $(this);
    var email = $(this_form).find('.required');
    var contact_loader = $(this_form).find('.contact-loader');

    var session = sessionStorage.getItem("hide_subscribe");

    if(session!=="1" || $(this_form).hasClass('sidebar-subscribe') || $(this_form).hasClass('footer-subscribe')){

        setTimeout(function(){
            $(this_form).parent().addClass('loaded');
        }, 1000);
        
        $(document).on('click touch', '.sbs-close', function(e){
            
            e.preventDefault();
            
            $(this_form).parent().removeClass('loaded');
            
            if (typeof localStorage === 'object') {
                try{
                    sessionStorage.setItem("hide_subscribe", 1);
                }catch (e){
                    console.log(e);
                }
            }
            
        });

        $(document).on('click touch', '.sbs-nf-close', function(e){
            e.preventDefault();
            $(this_form).find('.contact-loader').removeClass('error active success');
        });
    
        $(email).on('click touch', function(){
            $(this).removeClass('error-rqrd');
        });
    
    
        $(this_form).on('submit', function(e){
    
            e.preventDefault();
    
           
    
            if($(email).val()==='' || $(email).val()===undefined){
                $(email).addClass('error-rqrd');
                return false;
            }else{
                $(contact_loader).addClass('active');
                //send the formData via AJAX
                setTimeout(function(){
                    
                    $.ajax({
                        url: ajaxurl,
                        dataType: 'json',
                        type: 'POST',
                        data: {'action'  : 'submitSubscribeForm', 'email' : $(email).val() },
                        success: function(resp){
    
                            if(resp===1){
                                $(contact_loader).removeClass('active').addClass('success');
                                $(contact_loader).find('.nf-msg').html('Thank you for subscribing!');
                            }else if(resp===2){
                                $(contact_loader).removeClass('active').addClass('error');
                                $(contact_loader).find('.nf-msg').text('You have already subscribed.');
                            }else{
                                $(contact_loader).removeClass('active').addClass('error');
                                $(contact_loader).find('.nf-msg').text('There was a problem submitting the form. Please try again.');
                            }
                            
                        },
                        error: function(){
                            $(contact_loader).removeClass('active').addClass('error');
                            $(contact_loader).find('.notification-msg').text('There was a problem submitting the form. Please try again.');
                        },
                        complete: function(){
                            $(email).val('');
    
                            sessionStorage.setItem("hide_subscribe", 1);
    
                            setTimeout(function(){
                                $(this_form).parent().removeClass('loaded');
                            }, 3500);
                        }
                    });
    
                }, 2000);
    
            }
            
        });

    }//check session hide subscribe



    function changeCatAjax(cat, tax){
    
        $('.wine-tab-content, .wine-subcategory').html('');
        $('.wine-tab-wrap').find('.contact-loader').addClass('active');

        setTimeout(function(){
                    
            $.ajax({
                url: ajaxurl,
                dataType: 'json',
                type: 'POST',
                data: {'action'  : 'getWinesByCat', 'cat' : cat, 'tax' : tax  },
                success: function(resp){

                    $('.wine-tab-wrap').find('.contact-loader').removeClass('active');
                    $('.wine-tab-content').html(resp.wine_html);
                    $('.wine-subcategory').html(resp.wine_subcat);

                }
            });

        }, 1000);

    }
    
    $(document).on('click touch', '.btnShareThis', function(e){
        e.preventDefault();
    });

    $(document).on('click touch', '.wine-categories .btn-badge', function(e){

        e.preventDefault();

        $('.wine-categories li.current').removeClass('current');    

        var cat = $(this).attr('data-cat');
        var tax = $(this).attr('data-tax');

        $.ajax({
            url: ajaxurl,
            dataType: 'json',
            type: 'POST',
            data: {'action'  : 'getWinesByCat', 'cat' : cat, 'tax' : tax  },
            success: function(resp){
                History.pushState({state:{'cat':cat, 'tax':tax}}, resp.title, resp.permalink);
            }
        });

        changeCatAjax(cat, tax);
        
        $(this).parent().addClass('current');

    });


    $(document).on('click touch', '.wine-subcategory .btn-badge', function(e){

        e.preventDefault();

        $('.wine-subcategory li.current').removeClass('current');    

        var cat = $(this).attr('data-cat');
        var tax = $(this).attr('data-tax');

        $.ajax({
            url: ajaxurl,
            dataType: 'json',
            type: 'POST',
            data: {'action'  : 'getWinesByCat', 'cat' : cat, 'tax' : tax  },
            success: function(resp){
                History.pushState({state:{'cat':cat, 'tax':tax}}, resp.title, resp.permalink);
            }
        });

        changeCatAjax(cat, tax);
        
        $(this).parent().addClass('current');

    });


    History.Adapter.bind(window,'statechange',function(){ // Note: We are using statechange instead of popstate
        
        var State = History.getState(); // Note: We are using History.getState() instead of event.state

        var cat = State.data.state.cat;
        var tax = State.data.state.tax;

        changeCatAjax(cat, tax);

    });






}




